<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat 3D production",
    "pageDesc":"reating short movies, advertising campaigns and product visualizations using the whole the powers of animation service.",
    "mantra":"Capitalizing on the |powers of 3D .",
    "sec1Items":{
      "1":{
        "title":"Cartoon movies",
        "desc":"Integrating the 3D techniques into the process of movie creation to add a more realistic feeling to the stories and come up with high end visuals."
      },
      "2":{
        "title":"Commercials",
        "desc":"Whether a poster, GIF or video, we use 3D techniques to create campaigns that stick with your target audience and drive more buyers."
      },
      "3":{
        "title":"Product design",
        "desc":"From elemntyrcins to shoes and everyday gadgets, 3D helps us better visualize the product concept and add materials and colors that are similar to real life."
      }
    },
    "sec2":"End to end production methodology.",
    "sec2Items":{
      "1":{
        "title":"Modeling",
        "desc":"Starting with the project concept, we develop the characters, objects, environment in order to be appealing and functional for animation."
      },
      "2":{
        "title":"Shading",
        "desc":"Based on the mood desired, we pick the colors, lightning and textures needed by studying real objects and understanding the laws of physics to build up the product or movie identity."
      },
      "3":{
        "title":"Rigging",
        "desc":"From the models created, we start deforming the object based on real life cases and getting it ready for animation."
      },
      "4":{
        "title":"Layout",
        "desc":"For a perfect scene, we set the angels from which the product of character will be viewed then we select the frames and movements according to the storyboard created."
      },
      "5":{
        "title":"Rendering",
        "desc":"Compuatton the final images and building scene. Displaying the final output then rendering again until there are no errors and the output is launchable."
      }
    },

    "cta":"Turn your ideas into a <br> story today."
  },
  "ar": {
    "pageTitle":"الإنتاج ثلاثي الأبعاد",
    "pageDesc":"احصل على أفلام قصيرة وحملات إعلانية وتصورات كاملة للمنتج النهائي من خلال الإنتاج ثلاثي الأبعاد.",
    "mantra":"أجعل محتواك |أكثر حيوية.",
    "sec1Items":{
      "1":{
        "title":"أفلام الكرتون",
        "desc":"نعمل على دمج التقنيات ثلاثية الأبعاد أثناء إنشاء الأفلام من أجل إضافة مشاعر أكثر واقعية والحصول على أفضل صور."
      },
      "2":{
        "title":"الإعلانات تجارية",
        "desc":"سواءً كنت تريد إنشاء ملصقًا أو صورة GIF أو فيديو، فنحن نستخدم تقنيات ثلاثية الأبعاد لإنشاء حملات تعتمد على جمهورك المستهدف وتحفز المزيد من المشترين."
      },
      "3":{
        "title":"تصميم المنتجات",
        "desc":"بداية من تصميم الإلكترونيات إلى الأحذية والأدوات اليومية، يساعدنا التصميم ثلاثي الأبعاد على تصور مفهوم المنتج بشكل أفضل وإضافة ألوان ومواد تشبه الحياة الحقيقية."
      }
    },
    "sec2":"مراحل الإنتاج الشاملة.",
    "sec2Items":{
      "1":{
        "title":"عملية المودلينج",
        "desc":"عند التوصل إلى فكرة المشروع، نقوم بتطوير الشخصيات والكائنات والبيئة الخاصة بالمشروع لتكون جذابة وعملية للرسوم المتحركة."
      },
      "2":{
        "title":"الظل والنور",
        "desc":"تبعًا للحالة المزاجية المرغوبة، نختار الألوان والإضاءات والملامس المناسبة لدراسة الأشياء بشكلها الحقيقي، وفهم قوانين الفيزياء لبناء هوية المنتج أو الفيلم."
      },
      "3":{
        "title":"عملية الريجنج (Rigging)",
        "desc":"من النماذج التي تم إنشاؤها، نبدأ في تشكيل الكائن استنادًا إلى حالته في الحياة الحقيقية من أجل الاستعداد للرسوم المتحركة."
      },
      "4":{
        "title":"التصميم",
        "desc":"من أجل مشهد مثالي، قمنا بتعيين الزوايا التي سيتم من خلالها عرض شخصية المنتج ثم نختار الإطارات والحركات وفقًا للوحة العمل التي تم إنشاؤها."
      },
      "5":{
        "title":"عملية الريندرينج",
        "desc":"نقوم ببناء الصور النهائية والمشاهد، ثم نعرض الإخراج النهائي ثم الريندرينج مرة أخرى حتى لا يكون هناك أخطاء ويكون الإخراج غير قابل للوصول."
      }
    },

    "cta":"حول أفكارك إلى <br> قصص حقيقية. "
  }
}
</i18n>
